<template>
	<div class="option-container" :class="{ 'is-expanded': isExpanded }">
		<div class="pb-1 flex-space-between--start">
			<div class="flex-start--center flex-1">
				<div class="hover-effect"><SIcon name="drag-sign" /></div>
				<div class="hover-btn-effect ml-1 pl-2 flex-1" @click="$emit('setIsExpanded', !isExpanded)">{{ optData.label }}</div>

				<div class="flex-start--center">
					<SIcon name="caret" class="caret-icon mr-2" />
					<RoundButton v-show="canRemove && !readonly" @click="$emit('removeOption', optData)">
						<RemoveSvg />
					</RoundButton>
				</div>
			</div>
		</div>
		<v-expand-transition>
			<div v-show="isExpanded">
				<slot />
			</div>
		</v-expand-transition>
	</div>
</template>

<script>
import RemoveSvg from './assets/RemoveSvg';
import { ITEM_ONLY_ALLOWED_VALUE_TYPES } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';

export default {
	name: 'OptionContainer',
	components: {
		RemoveSvg,
	},
	props: {
		optData: { type: Object },
		readonly: { type: Boolean },
		isExpanded: { type: Boolean },
		canRemove: { type: Boolean, default: true },
	},
	data() {
		return {
			ITEM_ONLY_ALLOWED_VALUE_TYPES,
		};
	},
};
</script>

<style scoped lang="scss">
.option-container {
	transition: 0.4s;

	&.is-expanded {
		.caret-icon {
			transform: rotate(180deg);
			transition: 0.4s;
		}
	}

	> div:not(:nth-child(1)),
	> button {
		margin: 3px;
		padding: 3px 3px 3px 6px;
		background: #fafafa;
		border-radius: 6px;
	}

	.inputs {
		width: 100%;

		.text-field-style {
			padding: 0;
			border: none;
			border-radius: 6px;
			background-color: var(--white);
		}
	}

	.conf-btn {
		background-color: #d4d7dc;
	}
}
</style>
